<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Sub Skills">
        <v-card-actions>
        <a @click="$router.back()">
          <v-btn
            v-if="$vuetify.breakpoint.smAndUp"
            elevation="1"
            absolute
            right
            top
          >
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn
            v-else
            fixed
            right
            fab
            small
            color="grey lighten-2"
            elevation="1"
            class="mr-n2 mt-10"
            style="opacity: 0.6"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
        <v-card-text class="pt-0 pr-1"
          :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <v-card-title>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-text-field :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }" v-model="search"
            append-icon="mdi-magnify" class="ml-auto mb-2" label="Search" hide-details single-line
            style="max-width:350px;" />
          <v-btn v-if="isWrite" elevation="1" v-on:click="modalOpen()" :class="{ 'mt-2': $vuetify.breakpoint.xs }"
            color="accent">
            <v-icon left>mdi-plus</v-icon>
            Add
          </v-btn>
        </v-card-text>
        <v-divider class=" my-0 " />
        <v-data-table :search.sync="search" hide-default-footer :headers="headers" :items="subskills">
          <template v-slot:item.subSkillsName="{ item }">
            <div v-for="subSkills in item.gradeSubSkills" :key="subSkills.id">
              <p>
                {{ subSkills.name }}
              </p>
            </div>
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
          <template v-slot:item.description="{ item }">
            <div v-for="subSkills in item.gradeSubSkills" :key="subSkills.id">
              <p>
                {{ subSkills.description ? subSkills.description : '---' }}
              </p>
            </div>
          </template>
          <template v-slot:item.remark="{ item }">
            <div v-for="subSkills in item.gradeSubSkills" :key="subSkills.id">
              <p>
                {{ subSkills.remark ? subSkills.remark : '---' }}
              </p>
            </div>
          </template>
          <template v-slot:item.parameters="{ item }">
            <div v-for="subSkills in item.gradeSubSkills" :key="subSkills.id">
              <div>
                <router-link
                  :to="{ name: 'listParameters', params: { subSkillId: subSkills.id, subSkillName: subSkills.name } }">
                  <v-btn outlined class="px-2 ml-1 ma-1" min-width="0" small>
                    View Parameters
                  </v-btn>
                </router-link>
              </div>
            </div>
          </template>
          <template v-slot:item.actions="{ item }" v-if="isWrite">
            <div v-for="subSkills in item.gradeSubSkills" :key="subSkills.id">
              <v-btn color="success" class="px-2 ml-1 ma-1" @click="getSingleSubSkill(subSkills.id)" min-width="0" small>
                <v-icon small> mdi-pencil </v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </material-card>
      <v-dialog persistent max-width="900" v-model="modalOk" :active="modalOk" :on-cancel="() => {
        modalOk = false
        clearData()
      }
        ">
        <form @submit.prevent="addSkills">
          <v-card>
            <v-toolbar dark color="darkblue">
              <v-toolbar-title> Add Skill</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="() => {
                  ; (modalOk = false), clearData()
                }
                  ">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field label="Name" v-model.trim="subSkillName" placeholder="Sub Skill" required> </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-textarea rows="2" label="Description" clearable clear-icon="mdi-close-circle" v-model.trim="desc"
                    placeholder="..." maxlength="200" counter="200"> </v-textarea>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Remark" v-model.trim="remark" placeholder="remark" maxlength="200"> </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Position" v-model.trim="position" placeholder="position" type="number">
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-card-actions class="justify-end">
                    <v-btn color="success" @click="addSubSkills">{{ editMode ? 'Save' : 'Add' }}</v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </form>
      </v-dialog>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import Utils from '@/utils'
export default {
  props: ['skillId', 'skillName'],
  components: {
    MaterialCard
  },
  data () {
    return {
      subSkillName: '',
      isLoading: false,
      search: '',
      subskills: [],
      total: '',
      editMode: false,
      modalOk: false,
      desc: '',
      remark: '',
      position: null,
      isWrite: false,
      headers: [
        { text: 'Skill', value: 'name', sortable: true },
        { text: 'Sub Skills', value: 'subSkillsName', sortable: false },
        { text: 'Description', value: 'description', sortable: false },
        { text: 'Remark', value: 'remark', sortable: false },
        { text: 'Parameters', align: 'center', value: 'parameters', sortable: false },
        { text: 'Action', value: 'actions', align: 'center', sortable: false }
      ]
    }
  },
  created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    if (this.skillId) {
      this.getSubskills()
    }
  },

  methods: {
    addSubSkills: async function () {
      if (this.subSkillName === '') {
        this.errMsg('Name cannot be empty!')
        return false
      }

      if (this.editMode) {
        var formData = {
          name: this.subSkillName,
          isActive: true
        }
        // if (this.desc) {
        formData.description = this.desc
        // }
        // if (this.remark) {
        formData.remark = this.remark
        formData.position = this.position
        // }
      } else {
        formData = {
          gradeSkillID: this.skillId,
          gradeSubSkills: [
            {
              name: this.subSkillName,
              isActive: true
            }
          ]
        }
        if (this.desc) {
          formData.gradeSubSkills[0].description = this.desc
        }
        if (this.remark) {
          formData.gradeSubSkills[0].remark = this.remark
        }
        if (this.position) {
          formData.gradeSubSkills[0].position = this.position
        }
      }

      let url = this.editMode ? `${constants.API_URL}/api/grade-module/sub-skill/${this.selectedId}` : `${constants.API_URL}/api/grade-module/sub-skill`

      try {
        let { data } = await http.post(url, formData)
        if (data) {
          this.okMsg(`Sub-Skill Successfully created.`)
        }
        this.getSubskills()
        this.modalOk = false
        this.clearData()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    modalOpen () {
      this.modalOk = true
    },
    getSubskills: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/grade-module/sub-skill?gradeSkillID=${this.skillId}`)
        this.subskills = data
        this.total = this.subskills.length
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    getSingleSubSkill: async function (id) {
      this.editMode = true
      this.selectedId = id
      try {
        const { data } = await http.get(`${constants.API_URL}/api/grade-module/sub-skill/${id}`)
        this.modalOk = true
        this.subSkillName = data[0].name
        this.desc = data[0].description
        this.remark = data[0].remark ? data[0].remark : null
        this.position = data[0].position ? data[0].position : null
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    clearData () {
      this.subSkillName = ''
      this.remark = ''
      this.desc = ''
      this.editMode = false
      this.position = null
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
